import { mapGetters } from 'vuex';

/**
 * Átjelentkezés: az állapot és a visszaút. Az alsó sáv és a fejléc is ezt használja, hogy
 * ne csússzon szét a kettő.
 */
export default {
    data() {
        return {
            leavingImpersonation: false,
        };
    },

    computed: {
        ...mapGetters({
            impersonationUser: 'user/authenticated',
        }),

        impersonation() {
            return this.impersonationUser?.impersonation || null;
        },

        isImpersonating() {
            return !!this.impersonation?.active;
        },

        impersonatorName() {
            return this.impersonation?.impersonator?.name || '';
        },
    },

    methods: {
        async leaveImpersonation() {
            if (this.leavingImpersonation) {
                return;
            }

            this.leavingImpersonation = true;

            // Itt töltjük be, nem a fájl tetején: statikus importtal az api/axios és a
            // store körbe hivatkozna, és az axios undefined-ként érkezne az első
            // dispatchhez.
            const {default: impersonationService} = await import('@/api/impersonation');

            try {
                await impersonationService.stop();
            } catch (e) {
                const status = e?.response?.status;

                // 409: nincs hova visszalépni, a szerver ki is léptetett.
                // 403: a szerver szerint nincs is folyamatban átjelentkezés — a jelzés a
                //      felületen ragadt. Épp ilyenkor a legrosszabb hibát dobni: a
                //      felhasználó a visszaútra kattint, és ott marad, ahol volt.
                // Mindkettőből ugyanaz a kiút: eldobjuk az állapotot és újratöltünk.
                if (status !== 409 && status !== 403) {
                    this.leavingImpersonation = false;
                    throw e;
                }
            }

            impersonationService.clearCachedIdentity();

            // A törlés nem elég: a jogosultság-listát a bejelentkezés és az intézmény-váltás
            // tölti, más senki — enélkül üresen indulna az új munkamenet, és a felhasználó a
            // saját képernyőit sem érné el.
            await this.$store.dispatch('auth/permissions');

            // A kezdőlapra, nem újratöltésre: az előző képernyő gyakran hibaoldal.
            window.location.href = '/';
        },
    },
};
